{
  "Languages": {
    "SelectTitle": "Select your language",
    "Spanish": "Spanish",
    "English": "English"
  },
  "NotFound": {
    "Code": "404",
    "Title": "Not found",
    "Subtitle": "We could not find the page you were looking for"
  },
  "Loading": "Loading",
  "Header": {
    "MiCel": "Mi Cel",
    "Adelanto": "Instant cash",
    "Repatriation": "Repatriation",
    "AtmNetwork": "ATM Network",
    "Assistant": "Registration via Whatsapp",
    "HowItWorks": "How it works?",
    "WhySendola": "Why Sendola?",
    "ForPartners": "Become a partner",
    "AboutUs": "About Us",
    "SendolaCorp": "Sendola Corp",
    "LoginButton": "Log in",
    "SignupButton": "Register",
    "Personal": "Personal",
    "Business": "Business"
  },
  "Home": {
    "HeadingTitle": "<span>More Money.</span> No Borders.",
    "HeadingCallout": "America's Bank-to-Bank Global Payments Platform",
    "SendMoney": "Unlock Financial Freedom: Linking Migrant Communities to Reliable Banking and Payments",
    "SendMoneyDesktop": "Save, Spend and Send money globally, <b>your way</b>",
    "LoginTitle": "Start now!",
    "LoginSubtitle": "Enter your phone number to Log in",
    "Or": "O",
    "LoginButton": "Log in",
    "SignupButton": "Register",
    "ScrollCallout": "Send money to",
    "CountriesWeService": "Countries we serve",
    "Video": "<span>We're changing</span> the way you send money",
    "BankAccount": {
      "Title": "Need a bank account?",
      "Subtitle": "Open one now with a Sendola Partner",
      "Button": "Find a bank"
    },
    "CountriesSection": {
      "Title": "The world is smaller with",
      "Subtitle": "Send your money in pesos or euros with the same confidence as always.",
      "Countries": "countries",
      "NewDestinations": "new destinations",
      "Button": "Sign up now!",
      "Disclaimer": "Available in May 2025. Argentina from May 30th."
    },
    "Section1": {
      "Title": "Searching for better oportunities on USA"
    },
    "Section2": {
      "Title": "A flexible and global way of using your money",
      "Subtitle": "You choose how, where, and when to send your money."
    },
    "Section3": {
      "Title": "Benefits",
      "Subtitle": "In Sendola we strive everyday to offer you more benefits!",
      "ImageAlt": "Person with smartphone",
      "LogoAlt": "Benefits",
      "Bullet1": {
        "Title": "Payroll advance",
        "Paragraph": "Request an advance of your direct deposit when you need it.",
        "Button": "Discover Adelanto"
      },
      "Bullet2": {
        "Title": "Buy a high tier smartphone",
        "Paragraph": "Purchase the phone you want in flexible and conftarble payments.",
        "Button": "Buy Mi Cel"
      },
      "Bullet3": {
        "Title": "Complete repatriation without complications.",
        "Paragraph": "Complete peace of mind, even in the most difficult moments.",
        "Button": "Discover Contigo"
      }
    },
    "Section4": {
      "Title": "What our customers say:"
    },
    "Testimonial1": {
      "Name": "Anthony Gerardo Tovar",
      "Ocupation": "Martori Farms, Águila, Arizona",
      "Content": "A very useful tool for workers who come with the goal of getting ahead. The attention they provide is excellent at all times."
    },
    "Testimonial2": {
      "Name": "Renée Triay",
      "Ocupation": "CEO Glam2Go",
      "Content": "I've lived between Mexico and the US for 20 years, and money transfers were always a hassle. Now, with Sendola, I can send money to Mexico using Zelle for just $4.99. It's finally easy, convenient, and affordable!"
    },
    "Testimonial3": {
      "Name": "Mariana Cuervo",
      "Ocupation": "Colombian Professional",
      "Content": "Sendola has allowed me to access services that were previously denied to me or were very difficult to obtain. Now, everything is much more accessible."
    },
    "Modal": {
      "title": "Create your account quickly and easily",
      "singUpButton": "Register now",
      "or": "or",
      "whatsappButton": "I prefer to register via WhatsApp",
      "back": "Back",
      "hi": "Hello!"
    }
  },
  "Countries": {
    "MX": "Mexico",
    "IN": "India",
    "GT": "Guatemala",
    "PH": "Phillipines",
    "CN": "China",
    "DO": "Dominican Republic",
    "VN": "Vietnam",
    "SV": "El Salvador",
    "HN": "Honduras",
    "NI": "Nicaragua",
    "CA": "Canada",
    "PA": "Panama",
    "NG": "Nigeria",
    "CO": "Colombia",
    "BR": "Brazil",
    "AR": "Argentina",
    "CL": "Chile",
    "PL": "Poland",
    "PT": "Portugal",
    "America": "America",
    "Asia": "Asia",
    "Europe": "Europe",
    "Other": "Other Corridors"
  },
  "FloatingButton": {
    "Phone": "Give us a call",
    "Support": "Send us a whatsapp",
    "Faqs": "FAQS"
  },
  "Banners": {
    "AmericaGreat": "<span>For the Ones</span> Who Make America Great",
    "NewCountries": {
      "Title": "New destinations,",
      "Title2": "same benefits",
      "Subtitle": "Now you can send pesos to LATAM and euros to Europe with Sendola Pay.",
      "Button": "Learn more",
      "Disclaimer": "*Argentina starting May 30th"
    }
  },
  "Quoter": {
    "Amount": "How much would you like to send?",
    "Receive": "Your beneficiary will receive",
    "Account": "Direct to bank",
    "Cash": "Cash pick up",
    "ExchangeRate": "Exchange rate",
    "Fee": "Transaction fee",
    "PaymentMethodFee": "Fee:",
    "D2BPlaceholder": "Select a bank",
    "CPUPlaceholder": "Select a withdrawal point",
    "NoD2BDestination": "The selected country does not allow deposit to account.",
    "NoCPUDestination": "The selected country does not allow cash withdrawal.",
    "Button": "Send money",
    "Disclaimer": "*The shops and institutions may vary depending on the chosen destination.",
    "Disclaimer2": "This quote may vary based on the destination or payment method.",
    "Disclaimer3": "Prices and exchange rates are for reference only and may vary based on market conditions, destination country, payment method, and other factors. Sendola does not guarantee the displayed rates.",
    "Disclaimer4": "The exchange rates, fees, and other pricing information provided are for informational purposes only and do not constitute a final offer, quote, or binding agreement.",
    "DisclaimerViewMore": "Read more.",
    "DisclaimerExtended": "<b>Disclaimer: Informational Use Only</b><br><br>The exchange rates, fees, and other pricing information provided by Sendola’s website rate estimator are for informational purposes only and do not constitute a final offer, quote, or binding agreement. Actual transaction terms—including exchange rates, service fees, and total payout amounts—may vary depending on the destination country, payment method, transaction amount, market fluctuations, and regulatory requirements. <br><br>All pricing data is sourced from Uniteller Inc. and is subject to change without prior notice. Sendola does not guarantee the accuracy, completeness, or real-time availability of the information displayed. Users are solely responsible for reviewing and confirming the final transaction terms before initiating any transfer. <br><br>For finalized pricing and disclosures required under federal and state money transmission laws, including those set forth in the <b>Consumer Financial Protection Bureau (CFPB) Remittance Rule (12 CFR § 1005.30 et seq.),</b> please proceed to the transaction confirmation page or contact our customer service team.",
    "DeliveryMethod": {
      "Title": "Delivery method",
      "NotAvailable": "Unavailable for this destination"
    },
    "Channel": {
      "Title": "Choose the best deal for you",
      "BestFx": "Best FX",
      "CheaperFee": "No Sending Fee",
      "NotAvailable": "Deal currently not available"
    },
    "PaymentMethod": {
      "Title": "Payment method",
      "Placeholder": "Choose an option",
      "Zelle": "Zelle®",
      "Venmo": "Venmo®",
      "PayPal": "PayPal®",
      "Sendola ACH": "Your bank account (ACH)"
    },
    "PaymentMethodDesktop": {
      "Zelle": "Zelle®",
      "Venmo": "Venmo®",
      "PayPal": "PayPal®",
      "Sendola ACH": "ACH"
    },
    "Time": {
      "Zelle": "In minutes",
      "Venmo": "Same day",
      "PayPal": "In minutes",
      "Sendola ACH": "1-3 days"
    },
    "Total": {
      "Send": "Amount to send",
      "Fee": "Total fees",
      "TransactionFee": "Transaction fee",
      "PaymentMethodFee": "Payment method fee",
      "Total": "Total payment"
    }
  },
  "Cards": {
    "Card1": {
      "Title": "With your existing bank account",
      "Paragraph": "Send money back home directly from your bank."
    },
    "Card2": {
      "Title": "Or request an account with a bank",
      "Paragraph": "We help you open a bank account in your state in the USA:",
      "Bullet1": "Get an account and debit card without a credit history.",
      "Bullet2": "Link with Plaid to send money abroad easily."
    },
    "Card3": {
      "Title": "You choose how to pay:",
      "Paragraph": "Choose your payment method"
    },
    "Card4": {
      "Title": "Get your ideal phone in installments.",
      "Paragraph": "Obtain the phone you want with <b>convenient and flexible</b>, payments tailored to your needs."
    }
  },
  "Partners": {
    "Title": "Our Trusted Network and Partners",
    "Disclaimer": "Sendola is duly authorized and registered as a Money Transmitter in the State of Arizona and is registered to operate in the State of Montana. We provide P2P, C2B, and B2B payment coverage across all 50 U.S. states as an authorized agent of our strategic partners, including Uniteller, More Payments, and Uniteller Money Desk. For Ascendant, we serve as a commercial broker in the U.S. for B2B services. SentSprint will be joining our network soon.<br><br>For international payout operations, we work with leading partners including Tesored in Mexico, Appriza Pay across Mexico and Latin America, and GYT Continental in Guatemala. This robust network ensures the highest standards of compliance for secure and efficient cross-border transactions.<br><br>All transactions are subject to the terms and conditions of our partners and the applicable regulations in each jurisdiction."
  },
  "Footer": {
    "Address1": "Sendola Corp.",
    "Address2": "6710 E. Camelback Rd",
    "Address3": "Scottsdale, AZ 85253",
    "Phone": "Phone:",
    "PhoneNumber": "+1 (520) 342-0520",
    "ReportIssue": "Report a issue and support:",
    "SupportEmail": "support@sendola.io",
    "Email": "Email:",
    "ContactEmail": "contact@sendola.io",
    "Disclaimer": "Sendola is duly licensed and registered as a Money Transmitter in the State of Arizona and authorized to operate in the State of Montana. We provide P2P, C2B, B2B and B2C payment services across all 50 U.S. states as an authorized agent of our strategic partners, including <a class='text-blue-600' href='http://www.uniteller.com/state-licensing'>Uniteller Inc.</a>, More (a division of Uniteller), and Uniteller Money Desk.",
    "Disclaimer2": "For international payouts, we collaborate with leading partners such as Tesored in Mexico, Appriza Pay throughout Mexico and Latin America, and GYT Continental in Guatemala. This robust network ensures secure, efficient, and fully compliant cross-border transactions.",
    "Disclaimer3": "All transactions are conducted under the terms and conditions of our partners and in compliance with applicable regulations in each jurisdiction.",
    "UnitellerDisclaimer": "UniTeller | International Money Transfer & Payment Processing Services<br>State Licensing | UniTeller<br>State Licensing State License Number ALASKA 10013 ALABAMA SOC# 556 ARKANSAS 41717 ARIZONA MT-0903157 CALIFORNIA 1947 COLORADO 50121 CONNECTICUT MT-928684 DELAWARE 6583 DISTRICT OF COLUMBIA MTR928684 FLORIDA 051740 GEORGIA 18891 HAWAII HIMT015 IOWA MT-2002-0135 IDAHO 054 ILLINOIS MT - 154 INDIANA 6742 KANSAS 0020001 KENTUCKY SC383800 LOUISIANA 214 MAINE Number Not Issued MASSACHUSETTS FT928684 MARYLAND",
    "LegalInformation": "Legal information",
    "AtmNetwork": "ATM Network",
    "CardProgram": "Sendola Card Program",
    "About": "Why Sendola?",
    "SendolaNMLS": "Sendola NMLS ID - 2508481"
  },
  "Advancement": {
    "title": "Access up to 50% of your direct deposit in advance whenever you need it",
    "section1": {
      "title": "You decide how to spend it",
      "bullet1": "Send money home in advance",
      "bullet2": "Buy or pay for products or services",
      "bullet3": "Expenses or unforeseen events."
    },
    "section2": {
      "title": "Choose how much you want to get in advance",
      "fee": "Fee",
      "usd": "USD",
      "subtitle": "Up to 7 days before you get your direct deposit",
      "info": "*By subscribing to this service, the monthly payment will be automatically charged.",
      "doubts": "I have more questions about how it works.",
      "supportBtn": "Contact Support",
      "item1": "Up to 25% of your direct deposit",
      "item2": "Up to 35% of your direct deposit",
      "item3": "Up to 50% of your direct deposit"
    },
    "doubts": "I have more questions about how it works.",
    "supportBtn": "Contact Support",
    "info": "No interest. No credit check.",
    "titleForm": "Fill out the form to request your advance",
    "form": {
      "name": "First Name",
      "phone": "Phone Number (Whatsapp)",
      "lastName": "Last Name",
      "company": "Which company do you work for?",
      "contract": "When does your contract with the company end?",
      "infoAdvancement": "*Maximum amount to request: $1,000 USD",
      "advancement": "How much money do you want to advance? (USD)",
      "money": "Use of advance payment",
      "infoMoney": "*This helps us get to know you better",
      "button": "Request Service"
    },
    "terms": "<b>Please read carefully and sign accordingly.</b> I acknowledge that I have read the Terms and Conditions and agree to be bound by all terms, conditions, rules, and regulations set forth or incorporated by reference herein. Keep a copy of this signed document for your records.",
    "termsLink": "Terms & Conditions"
  },
  "AtmNetwork": {
    "MainTitle": "ATM Network Locator",
    "MainSubtitle": "More than 100,000 ATMs",
    "SecondaryTitle": "ATM Network Locator",
    "SecondarySubtitle": "Find your closest ATM to withdraw your money",
    "Callout": "Click on the network that suits you best and find the nearest ATM",
    "Disclaimer": "*Sendola and USI FCU don't charge for using the CO-OP Network, however the Credit Unions have the right to charge a fee. System charge $1.00 convenience fee."
  },
  "Legal": {
    "Title": "Legal information",
    "Address": "Sendola Corp. 3040, Post Oak Blvd. Floor 18 Houston, TX 7, U.S.A.",
    "Bullet1": "Terms of Service",
    "Bullet2": "Privacy Policy",
    "Bullet3": "Data & Retention Policy",
    "Bullet4": "Data Security Policy",
    "Bullet5": "Disclosure and Electronic Communications Agreement",
    "Bullet6": "USA Patriot Act Notice",
    "Bullet7": "Accesibility Statement",
    "TermsLink": "https://s3.us-west-1.amazonaws.com/sendola.io/Disclosures+y+Legales+/Sendola.io/Sendola+Terms+of+Service++(8092025).pdf"
  },
  "Repatriation": {
    "title": "Assistance plans <b>that adapt to you</b>",
    "section1": {
      "title": "Make every moment count with you. Contigo* a service that supports you even when you’re not there.",
      "bullet1": "Repatriation",
      "bullet2": "Logistics",
      "bullet3": "Management"
    },
    "section2": {
      "title": "Choose your plan:",
      "item1": {
        "name" : "Individual",
        "title" : "Membership holder",
        "subtitle": "(No age or cause of death restrictions)",
        "first" : "Included with your Sendola Account for sending $500 USD or more per month to your home country.",
        "second" : "Body collection",
        "third": "Aesthetic body grooming", 
        "fourth": "Metal Coffin",
        "fifth": "Funeral room",
        "sixth": "Procedures management",
        "seventh": "Legal advice via telephone",
        "eighth": "Thanatological assistance",
        "footer": "*Service included when sending money abroad with a transfer of $500 USD or more per month."
      }, 
      "item2": {
        "name" : "Family",
        "title" : "Plan holder, spouse, and children",
        "subtitle": "(No restrictions on age or number of children)",
        "first" : "Body collection",
        "second" : "Aesthetic body grooming",
        "third": "Metal Coffin", 
        "fourth": "Velatory Room",
        "fifth": "Administrative Procedures",
        "sixth": "Legal advice via telephone",
        "seventh": "Thanatological assistance",
        "price": "Price: 1.99 USD",
        "footer": "*By subscribing to this service, the monthly payment will be automatically charged."
      },
      "item3": {
        "name" : "Parents Only",
        "title" : "Parents of the owner",
        "first" : "Body collection",
        "second" : "Aesthetic body grooming",
        "third": "Metal Coffin", 
        "fourth": "Velatory Room",
        "fifth": "Administrative Procedures",
        "sixth": "Legal advice via telephone",
        "seventh": "Thanatological assistance",
        "price": "Price: 1.99 USD",
        "footer": "*The purchase of the “parents only” plan is limited to holders under 35 years of age; Those aged 35 or over will not be able to hire this plan."
      }
    },
    "doubts": "Learn what you need to know to receive funeral assistance",
    "supportBtn": "I want assistance",
    "info": "Fill out the following form to subscribe to your service.",
    "titleForm": "Purchase your plan",
    "form": {
      "name": "Name",
      "phone": "Phone Number (Whatsapp)",
      "lastName": "Surname",
      "company": "Which company do you work for?",
      "contract": "When does your contract with the company end?",
      "plan": "Choose your plan",
      "check": "*By submitting this form you accept that your information is true and agree that a monthly charge will be made to your Sendola Account.",
      "button": "Purchase",
      "service": "This service is provided by ASOCIACIÓN NECROLÓGICA MEXICANA, S.A. DE C.V.",
      "familyPlan":  "Family Plan",
      "onlyParentsPlan": "Only Parents Plan"
    },
    "terms": "<b>Please read carefully and sign accordingly.</b> I acknowledge that I have read the Terms and Conditions and agree to be bound by all terms, conditions, rules, and regulations set forth or incorporated by reference herein. Keep a copy of this signed document for your records.",
    "termsLink": "Terms & Conditions",
    "sinister": "Contact us",
    "sinisterSubtitle": "In case of an incident, for funeral assistance directly with provider (ASOCIACIÓN NECROLÓGICA MEXICANA, S.A. DE C.V.)",
    "phone1": "Lada (no cost):",
    "phone2": "Call from Mexico: ",
    "sendEmail": "Send us an email",
    "visitFaqs": "Visit our FAQs",
    "customerService": "Customer Service"
  },
  "MyPhone": {
    "title": "Getting the phone of your dreams can be expensive, so it's better to buy it in installments.",
    "section1": {
      "title": "Your best ally is <b>having your direct deposit</b> to be able to get your new cellphone.",
      "bullet1": "Set up your direct deposit",
      "bullet2": "Order your phone by filling out the form",
      "bullet3": "Receive your new phone"
    },
    "section2": {
      "title": "Available Phones",
      "subtitle":"Click on the name of each model to see more details:",
      "labelPaymentPlan": "Example of payment plan:",
      "weeklyPayment": "Weekly Payment:",
      "usd": "usd",
      "term": "Installments:",
      "weeks": "weeks",
      "total": "Total:",
      "shipping": "Shipping cost included.",
      "estimated": "Estimated delivery time: 7 business days.",
      "pricesTerms": "Prices and terms are subject to change without prior notice and upon delivery of a quote.",
      "availability": "Product availability is subject to change and cannot be guaranteed.",
      "getPhone": "Get the phone",
      "anotherPhone": "If you haven't found a phone you like, let us know which one you would like to get a quote for.",
      "quotePhone": "Quote other phone",
      "infoBenefit": "An exclusive benefit of having your payroll direct deposit in your Sendola account",
      "step1": "Choose a model",
      "step2": "Fill out the form on our website",
      "step3": "Receive your offer to purchase your phone in installments",
      "step4": "Sign the offer and wait to receive your phone",
      "infoDirectDeposit": "*Set Direct Deposit with your Sendola Account to enjoy this benefit."
    },
    "section3": {
      "banner": "Fill out the following form to <b>pre-order your new phone:</b>",
      "titleForm": "How do we know each other?",
      "name": "Full Name",
      "surname": "Last Name",
      "whatsapp": "Whatsapp Number",
      "work": "Where do you work?",
      "chooseCompany": "Choose a company",
      "endContract": "When does your contract with the company end?",
      "selectDate": "Select a date",
      "subtitleForm": "Choose a product:",
      "product": "Which product you want?",
      "model": "Choose the phone model",
      "modelPlaceholder": "Choose an option",
      "quote": "Want to quote other cellphone",
      "quotePlaceholder": "Write here the model and brand",
      "quoteTerms": "By filling out this form, you agree our Terms and Conditions and pre-order the chosen product. Our team will contact you for more details",
      "buttonPreOrder": "Pre-order",
      "termsAndConditions": "Terms and Conditions",
      "productOption1": "CellPhone + SIM (chip)",
      "productOption2": "Just Cellphone",
      "productOption3": "Just SIM (chip)",
      "selectSmartphone": "Select"
    }
  },
  "Faqs": {
    "title": "FAQs",
    "message": "Thank you for choosing Sendola! We understand that you may have questions about our products and services, policies, and more. To make your experience seamless, we've compiled a list of frequently asked questions to provide you with quick and informative answers.",
    "chooseCategory": "Choose a category",
    "search": "Looking for something?",
    "category": {
      "tab1": {
        "title": "Get to know Sendola",
        "item1": {
          "title": "What is Sendola?",
          "text": "Sendola is a financial technology company and works with US regulated entities for the issuing of electronic money and payment instruments. Banner Bank is a member of the FDIC. USI Federal Credit Union is a member of the NCUA."
        },
        "item2": {
          "title": "How long does a transaction take to complete?",
          "text": "The transfer time depends on the type of transfer (direct to bank accounts or for cash pickup).  <br/><br/>However, we can tell you that ON AVERAGE: <br/><br/><b>MEXICO:</b><br/>From Monday to Friday, D2B transfers to Mexico take between 20 and 30 minutes to be paid. On weekends and holidays, they can take up to 2 hours. CPU transfers to Bancoppel or Financiera del Bienestar take around 10 minutes to be available for the user to pick up. The rest of the CPU destinations are available 30 minutes after sending.<br/><br/><b>GUATEMALA:</b><br/>D2B transfers to Banco G&T are paid on average in 40 minutes; to other banks, they may take up to 2 hours. CPU transfers are available 30 minutes after sending."
        },
        "item3": {
          "title": "What security measures do you use to protect my data?",
          "text": "At Sendola, your security is our priority. We implement several measures to ensure that your data is always protected:",
          "point1": "Restriction of data access",
          "point2": "Data encryption",
          "point3": "Implementation of confidentiality and data retention policies",
          "point4": "Cybersecurity programs",
          "point5": "Physical security measures",
          "point6": "Confidentiality agreements"
        },
        "item4": {
          "title": "What are the fees for sending money?",
          "text": "The exchange rate varies depending on:",
          "point1": "Destination country ",
          "point2": "Type of transfer (D2B or CPU)",
          "point3": "Bank or institution where the CPU is picked up",
          "point4": "Amount sent",
          "text2": "As well as 'market' conditions. The market exchange rate changes every minute. We update the exchange rate daily."
        },
        "item5": {
          "title": "Can I send money to any country?",
          "text": "You can send money to bank accounts or for cash pickup in: Mexico, Guatemala, Argentina, Bolivia, Brazil, Chile, Colombia, Peru, Panama, and Uruguay."
        }
      },
      "tab2": {
        "title": "Are you returning to your country?",
        "item1": {
          "title": "Do I need to activate my card for use outside the United States?",
          "text": "Yes, send a message requesting the activation of your card for international use, so you won't have any issues when trying to pay at establishments or make withdrawals."
        },
        "item2": {
          "title": "Did you activate Sendola with a phone from the United States that you will no longer have in your country?",
          "text": "If you currently have a cell phone number you will use in your country, you can make the change before leaving the United States. If you do not yet have your country's phone number, you can contact us when you are in Mexico or Guatemala to change the number. In any case, call our service center or send a message via WhatsApp, where we will verify your identity and assist you with the change."
        },
        "item3": {
          "title": "Will I be able to count on the money from my Sendola account in my country?",
          "text": "Of course. The money in your account is yours and you can access it wherever you are. There are 3 ways to access it in Mexico/Guatemala:",
          "point1": "Using Sendola’s money transfer service, you can send funds to your bank account in your country.",
          "point2": "<b>Withdrawing cash from an ATM.</b> You can withdraw your money at any ATM in your country that accepts VISA. The amounts and fees for ATMs in Mexico or Guatemala depend on the ATM owner (average $3 USD). Your USI-Sendola card will charge you $1 USD per withdrawal.",
          "point3": "<b>Paying directly with your Sendola card at any establishment that accepts VISA.</b> This option will be available as long as you have money in your account. The fee for using your USI-Sendola card at establishments is 1% of the total purchase amount."
        }
      },
      "tab3": {
        "title": "Global Payments",
        "item1": {
          "title": "What is Sendola Global Payments?",
          "text": "Sendola Global Payments is Sendola's solution for individuals who wish to send money from the United States to other countries, providing a secure and efficient cross-border payment service."
        },
        "item2": {
          "title": "What countries can I send money to?",
          "text": "At Global Payments you can send money to México, Guatemala, Honduras, El Salvador, Colombia, Bolivia, Ecuador, Perú, Uruguay, Brazil, Argentina y Chile; We continue working to reach more countries every day."
        },
        "item3": {
          "title": "Why do I need to share my device location?",
          "text": "For compliance reasons, it is very important that you share your location."
        },
        "item4": {
          "title": "Can I send money if I refuse to share my device's location?",
          "text": "No,  it is very important that you share your location."
        },
        "item5": {
          "title": "If I accidentally decline to share my device's location, how can I share the location so I can Send Money?",
          "text": "You can share the location of your device by selecting Settings option, then Location –Activate Location."
        },
        "item6": {
          "title": "What locations am I allowed to Send Money from?",
          "text": "You can send money from any state in the United States of America. You are not able to send money from outside of the United States."
        },
        "item7": {
          "title": "What documents can I use to validate my identity during the registration process?",
          "text": "Documents you can use to validate your identity are: ",
          "point1": "Mexico: INE and Passport ",
          "point2": "Guatemala: DPI - Personal Identification Document and Passport ",
          "point3": "United States: Visa, Residency Card, Driver's License or Social Security Number"
        },
        "item8": {
          "title": "How will I be informed that my registration process is complete so I may start sending Money Transfers? ",
          "text": "You will receive either an email informing you that your validation process has been approved or when you access Global Payments service you will receive an approval message."
        },
        "item9": {
          "title": "What is a payment method and what payment methods do I have to Send Money?",
          "text": "The payment method is the source of the funds from which you send money. The payment methods available to Send Money are Sendola Pay and ACH (Use of Funds from an external bank account)."
        },
        "item10": {
          "title": "What is Sendola Pay?",
          "text": "Sendola Pay is the use of your Sendola One account to send money."
        },
        "item11": {
          "title": "Can I send money if I don't have Sendola One account?",
          "text": "Yes, you can send money using any United States bank account to make your money transfers using ACH (Use of Funds from an External Bank Account)."
        },
        "item12": {
          "title": "What is the ACH (Use of Funds from an External Bank Account) payment method?",
          "text": "ACH is the use of any United States bank account to Send Money."
        },
        "item13": {
          "title": "What is the maximum amount allowed to be sent through a money transfer transaction using Sendola Pay or ACH (Use of Funds from an external bank account)?",
          "text": "The maximum amount for a Money transaction using Sendola Pay or ACH (Use of Funds from a United States bank account) is $1,500 USD."
        },
        "item14": {
          "title": "How many transactions can I make daily and monthly?",
          "text": "Daily, you can send up to 3 transactions using your Sendola Pay or 6 transactions using ACH (Use of Funds from an external bank account). Monthly you can send up to 12 transactions using Sendola Pay or ACH (Use of Funds from a United States account)."
        },
        "item15": {
          "title": "What is a delivery method and what delivery methods do I have to send money?",
          "text": "Delivery methods are the options you have to send money. The delivery methods we have available are:",
          "point1": "Direct to Bank",
          "point2": "Cash Pick up"
        },
        "item16": {
          "title": "Can I send money if my Recipient does not have a bank account?",
          "text": "Yes, you can Send Money even if your beneficiary does not have a bank account, with the Cash Pick up payment method."
        },
        "item17": {
          "title": "What information do I require to register my payment beneficiary in the Deposit on Account scheme?",
          "text": "The information requested from the Beneficiary in the Account Deposit scheme is: To send money to Mexico, you require the Banking Code. To send money to Guatemala, you require the G&T account number. The personal information requested from the Beneficiary is: Full name, alias (optional), Date of birth, Full address, Telephone number and Email."
        },
        "item18": {
          "title": "What information do I require to register my Recipient in Cash Pickup?",
          "text": "The information requested from the Recipient in Cash Pick up is: <br/>Full name, alias (optional), Date of birth, Full address, Telephone number and email."
        },
        "item19": {
          "title": "For Mexico, to which Banks can I Send Money utilizing Direct to Bank?",
          "text": "When sending money through Direct to Bank, you can send funds to any Bank Account (Clabe -Standardized Banking Account) of the Mexican Financial System. "
        },
        "item20": {
          "title": "For Mexico, to which Cash Pickup points can I Send Money when utilizing Cash Pick up?",
          "text": "In Mexico, you can Send Money through the Cash Pick up delivery method to Bancoppel, Chedraui, Financiera para el Bienestar, Libertad Servicios Financieros and Waldos."
        },
        "item21": {
          "title": "In which branch of a Cash Pickup location can my Recipient pick up their cash?",
          "text": "Your Recipient can collect their cash at any branch of the selected Cash Pickup point."
        },
        "item22": {
          "title": "How do I know that the money has already been delivered to my Beneficiary?",
          "text": "When collecting at the counter, both you and the beneficiary will receive a notification by mail."
        },
        "item23": {
          "title": "For Guatemala, to which Banks can I Send Money utilizing Direct to Bank?",
          "text": "The available Bank for sending money to Guatemala utilizing the Direct to Bank method is G&T."
        },
        "item24": {
          "title": "For Guatemala, in which Cash Pickup points can I Send Money when utilizing Cash Pick up?",
          "text": "In Guatemala you can send the payment for Cash Pickup to G&T."
        },
        "item25": {
          "title": "How can I view my transaction receipt?",
          "text": "Your transaction receipt can be downloaded either from the receipt screen at the time of the transaction or from the email confirmation of the transaction."
        },
        "item26": {
          "title": "What information do I require to register my Recipient in the Direct to Bank scheme?",
          "text": "The information requested from the Recipient’s Account is: To send money to Mexico, you require the account number (Clabe - Standardized Banking Account). To send money to Guatemala, you require the G&T account number. The personal information requested from the Recipient is: Full name, alias (optional), Date of birth, Full address, Telephone number and email."
        },
        "item27": {
          "title": "How can I contact Sendola Customer Service?",
          "text": "At Sendola we are available to answer any questions you may have please call 832-730-2683, email <span class='text-violet-500'>support@sendola.io</span> or write to us using the Contact Us option at the bottom of the Global Payments page."
        }
      },
      "tab4": {
        "title": "Sendola One",
        "item1": {
          "title": "What is Sendola One?",
          "text": "Sendola One is a platform with the highest security standards that allows you to have a checking and savings account with USI Federal Credit Union (a member of the NCUA) and an International (Visa) card so that you can access your money available whenever you need it. With this card, you can access your cash at the CO-OP ATM network, receive your paycheck, save money, receive and make payments, and automatically access additional benefits we have for you"
        },
        "item2": {
          "title": "What are the benefits of Sendola One? ",
          "text": "Sendola One allows you to have benefits such as",
          "point1": "a. Direct deposit from your employer. ",
          "point2": "b. Receive funds or other payments directly to your card via ACH.",
          "point3": "c. You can pay for services with your Sendola One such as balance purchases or sending money abroad with Sendola Global Payments. ",
          "point4": "d. Your card is Visa(R) backed so it works in any country."
        },
        "item3": {
          "title": "How can I access the benefits of Sendola One?",
          "text": "It is very simple, just complete your registration and verify your identity in the SendolaOne WebApp and you will be able to access a virtual account and in a few days you will receive your physical card at your home."
        },
        "item4": {
          "title": "How can I access the benefits of Sendola One?",
          "text": "It is very simple, just complete your registration and verify your identity in the Sendola One WebApp and you will be able to access a virtual account, and, in a few days, you will receive your physical card."
        },
        "item5": {
          "title": "What type of purchases can I make with my Sendola card?",
          "text": "You can use your card for purchases at any merchant that accepts Visa (R); online and withdraw cash at any participating ATM network. Both in the United States and anywhere in the world."
        }
      }
    }
  },
  "PendingRequest": {
    "title": "We have received your request",
    "subtitle": "Our team is reviewing your request and will contact you by <b class='text-green-500'>WhatsApp</b> as soon as possible.",
    "btnAction": "Close"
  },
  "BannerBank": {
    "title": "Sendola in partnership with Banner Bank offers you: <strong>Personal checking account</strong>",
    "subtitle": "Banner Bank is a great choice for you",
    "text": "Discover why it's the best choice for managing your money in the United States.",
    "section1": {
      "bullet1": "Mastercard Debit Card accepted worldwide.",
      "bullet2": "Bank anytime from your favorite device.",
      "bullet3": "Set up recurring payments with your debit card.",
      "bullet4": "Mastercard® Zero Liability Protection.",
      "bullet5": "<a href='https://locations.bannerbank.com/search' class='underline' target='_blank'>Nationwide ATM convenience.</a>",
      "terms": "Terms and conditions"
    },
    "section2": {
      "title": "Link your account with Sendola",
      "subtitle": "If you already have a Banner Bank account, link it to your Sendola account quickly and securely through Plaid, and receive <b>additional benefits!</b>",
      "bullet1": "$25.00 USD account opening gift.",
      "bullet2": "Receive your paycheck in your account via direct deposit.",
      "bullet3": "Fee refund on +$1,000 USD transfers with Zelle on Sendola if you use Banner Bank.",
      "bullet4": "All the benefits of being a Sendola user:",
      "button": "Discover them!"
    },
    "buttonConnect": "I have an account, link now",
    "section3": {
      "title": "Open your Banner Bank account",
      "subtitle": "Get your card easily:",
      "request": "Request it at",
      "request2": "different locations",
      "location1": {
        "title": "Tortilleria Santa Fe",
        "point1": "With assistance from the Sendola team.",
        "point2": "Royal City, Washington.",
        "point3": "Every Friday from 12 p.m. PT to 5 p.m. PT.",
        "textLink": "View address"
      },
      "location2": {
        "title": "Banner Bank branches",
        "point1": "Yakima",
        "point2": "Sunnyside",
        "point3": "Hermiston",
        "washington": ", Washington",
        "oregon": ", Oregon"
      }
    }
  },
  "Errors": {
    "fieldRequired": "This field is required"
  },
  "WhySendola": {
    "Heading": "Why Sendola",
    "Promise": "Our Promise",
    "Mision": "Mission & Values",
    "Cards": {
      "Card1": {
        "Title": "Low Fees:",
        "Paragraph": "The days of taking advantage of immigrants are over. Our fees? As low as we can get them thanks to the Sendola banking network."
      },
      "Card2": {
        "Title": "On-time Delivery:",
        "Paragraph": "Your money when you need it. Fast and reliable and always on time or we'll refund your fees."
      },
      "Card3": {
        "Title": "Pay Your Way:",
        "Paragraph": "We believe in payment freedom. The more ways to pay, the freer you are - that's our promise, always."
      },
      "Card4": {
        "Title": "Safe & Secure:",
        "Paragraph": "Sleep easy. We're like a vault, keeping your money safe and sound - thanks to the strict standards of our Sendola banking network."
      }
    },
    "MessageFromCeo": {
      "Title": "Message from CEO",
      "Content": "As the <span>founder and CEO of Sendola,</span> I am immensely proud to introduce you to a <span>platform</span> where <span>integrity, security, and inclusivity</span> drive everything we do. Sendola is more than a payment company; we are a community <span>enabler that bridges</span> gaps across continents and cultures."
    },
    "BankingBanner": "“We believe that banking is <span>freedom</span><span>”</span>",
    "Texts": {
      "Card1": {
        "Paragraph1": "If your financial services are not affordable or accessible <span><span>- you are not free.</span></span>",
        "Paragraph2": "If you are forced to use cash because you can't obtain a debit card and checking account <span>- you are not free.</span>",
        "Paragraph3": "If you cannot move your money easily to support your family members or celebrate a birthday of an uncle on the other side of the world <span>- you are not free.</span>"
      },
      "Card2": {
        "Paragraph1": "<span>No immigrant</span> in the United States should be subject to a different banking system.",
        "Paragraph2": "Our impact is not for the few but for the many—the millions of Hispanic, Indian, and Asian immigrants who seek the <span>American dream.</span>",
        "Paragraph3": "Whether you're here on an <span>employer-sponsored visa</span> or as a <span>newly settled migrant,</span> you deserve the same opportunity to save, spend, and send money as everyone else.",
        "Paragraph4": "That's why we strive to provide a service that bridges the divide between <span>financial access in the U.S.</span> and the families waiting on the other side of the world."
      },
      "Card3": {
        "Title": "Our approach is distinct",
        "Paragraph1": "Not merely because of our values or our mission to dissolve borders in financial transactions, but because <span>we integrate seamlessly into the banking systems</span> you already trust. At Sendola, we believe that affordable banking is a fundamental right. Our relentless focus on security and trust is evident in the design of our platform, we are a service and a platform that believes to truly connect the world, we must integrate with the world, not make the world integrate with us.",
        "Paragraph2": "Envisioned as the <span>“Zelle of global payments”,</span> Sendola revolutionizes how account holders at banks and members of credit unions across the country manage their finances. Our platform transcends traditional barriers, making it as easy, accessible, and affordable as possible to save, spend, and send money globally. <span>Freedom in financial services isn't about the number of apps on your phone—it's about the simplicity and affordability of those services.</span>",
        "Paragraph3": "Our future and our promise is defined by payment freedom, <span>secured by affordable rates and the unwavering security of the United States banking system.</span> With Sendola, financial freedom is not a privilege—it's a right accessible to everyone, bridging worlds and bringing people closer.",
        "Paragraph4": "Together, let's redefine the landscape of financial services and ensure that every hardworking individual in the U.S. has the opportunity to enjoy payment freedom the way it was intended - <span>without boundaries. This is Sendola.</span>",
        "Signature1": "Abrazo fuerte,",
        "Signature2": "Enrique Huesca",
        "Signature3": "A very grateful CEO & Founder"
      }
    }
  },
  "HowItWorks": {
    "Heading": "How it works",
    "Section1": {
      "Title": "How to Join Sendola",
      "Step1": {
        "Title": "Create Your Account",
        "Paragraph": "No ID required to sign up! Open your account with your full name, date of birth, and phone number"
      },
      "Step2": {
        "Title": "Connect Your Bank with Plaid or add your Card",
        "Paragraph": "With our partner, Plaid, you can connect your bank account in a few simple steps enabling your seamless banking experience."
      }
    },
    "Section2": {
      "Title": "How to send money with Sendola",
      "Step1": {
        "Title": "Quote your Payment",
        "Paragraph": "Add the amount you want to send, pick the destination country, and your payout method."
      },
      "Step2": {
        "Title": "Add your recipient and save it!",
        "Paragraph": "Enter the name and address of the person you want to send money to. But, don't forget to save it!"
      },
      "Step3": {
        "Title": "Choose your Payment Preference",
        "Paragraph": "Choose your payment speed by selecting our “Express - In Minutes” option when paying via Zelle, or “Economy - Same Day” option when paying via Venmo, or our “Economy - 1-4 Business Days” option when paying via ACH."
      }
    },
    "Section3": {
      "Title": "How to send with Zelle",
      "Subtitle": "Our preferred way to send money quickly!"
    }
  },
  "ForPartners": {
    "Heading": "Become a partner",
    "Button": "Contact us",
    "Section1": {
      "Title": "What is Sendola?",  
      "Subtitle": "Linking <span>migrant communities</span> to Reliable Banking and Payments"
    },
    "Section2": {
      "Title": "<span>National market</span> opportunity",
      "ImmigrantsCount": "45,300,000",
      "ImmigrantsText": "Immigrants",
      "ForeignCount": "22,500,000",
      "ForeignText": "Foreign born from Sendola countries",
      "RemittancesCount": "$210 billion",
      "RemittancesText": "Remittances sent from the US in 2021"
    },
    "Section3": {
      "Title": "Why Connect with Sendola",
      "Subtitle": "Sendola: Connecting you to the Top Pay-out Destinations from the U.S. ($Millions)",
      "OtherCountries": "Other countries where we serve",
      "Disclaimer1": "KNOMAD/World Bank Bilateral Remittance Matrix 2021, December 2022.",
      "Disclaimer2": "For Mexico: Banxico, Remittances Information Structure (full year, 2023).",
      "Disclaimer3": "*Countries coming soon to Sendola's Global Payments service."
    },
    "Section4": {
      "Title": "Why Partner with Sendola",
      "Subtitle": "A secure financial solution for any Immigrant. No matter their story.",
      "Zelle": "We are the <b>Zelle</b> of <span>Global Payments</span>",
      "Cards": {
        "Card1": {
          "Title": "Expand your Business",
          "Content": "Securely serve the millions of professionals that send cross-border payments."
        },
        "Card2": {
          "Title": "Go further",
          "Content": "Provide more than just traditional financial services. Close the loop for professional migrants sending money across borders."
        },
        "Card3": {
          "Title": "ATM Network Access",
          "Content": "Our vast network of ATMs ensures that users can access banking operations even in remote areas."
        },
        "Card4": {
          "Title": "Presence and Trust",
          "Content": "Build long-term relationships by offering valuable services to this community."
        }
      }
    },
    "Section5": {
      "Title": "Who trusts Sendola?",
      "Subtitle": "Banking & Credit Union Partners",
      "Paragraph": "Our Banking & Credit Union Partners recognize the significant challenges in expanding the financial opportunities for professional migrants in the U.S. With trust in Sendola they have expanded their services to small communities with banking solutions that cater to local needs.",
      "Locations": "State Locations",
      "Title2": "<span>Easing the intimidation</span> <br>of approaching large financial institutions:",
      "Subtitle2": "<b>Sendola and Banks Partnership</b> offers to each customer the possibility of a:",
      "You": "You",
      "Together": "Together",
      "Icons": {
        "Icon1": "Checking Account",
        "Icon2": "Debit Card",
        "Icon3": "Global Payments",
        "Icon4": "Professional Migrant Communities",
        "Icon5": "Next Level Communication",
        "Icon6": "Integrated Online Banking"
      }
    },
    "Section6": {
      "Title": "Our ATM Network",
      "Subtitle": "<span>\"Cash can still be king\"</span>",
      "Points": {
        "Point1": {
          "Title": "Closing the loop",
          "Content": "Enjoy an extended network of ATMs placed to serve rural and client-focused account holders"
        },
        "Point2": {
          "Title": "Fee Incentives",
          "Content": "All we ask is that our partnerhship serves our clients. Provide ATM incentives to open an account with Direct deposit."
        },
        "Point3": {
          "Title": "Financial Inclusivity",
          "Content": "ATM placement is key to fulfilling our commitments to serving our underbanked community."
        },
        "Point4": {
          "Title": "Cash Is still King",
          "Content": "Sendola users depend on their ability to withdraw cash. Our ATM network solves that problem for them."
        },
        "Point5": {
          "Title": "Serve without the Work",
          "Content": "Our ATMs are serviced differently. Remote locations. Frequent replenishments. <b>Let us do the work.</b>"
        },
        "Point6": {
          "Title": "Bridging the Gap",
          "Content": "Our ATM network is growing. Help us expand to serve more of your clients. We'll still do the work."
        }
      },
      "CostToYou": "Cost to you:",
      "Cost": "$0.00",
      "Network": "Out Network is Your Network",
      "Steps": {
        "Step1": {
          "Title": "Just ask!",
          "Content": "Ask us how we can begin serving your existing and future clients and account holders. We serve nationwide!"
        },
        "Step2": {
          "Title": "ATM Incentives",
          "Content": "Our ATM network is growing. Help us expand to serve more of your clients. We'll still do the work."
        },
        "Step3": {
          "Title": "Sendola's Network",
          "Slashed": "Our",
          "Content": "Our partnership provides an ATM-network and quick placement process for our clients and your account holders."
        }
      }
    },
    "Section7": {
      "Title": "Highlights",
      "Points": {
        "Point1": "Our type of user transacts 5x more on average than a regular user",
        "Point2": "Low Fees for underserved communities",
        "Point3": "Up to 2 fee refunds with Sendola banking partners",
        "Point4": "Access to locations with high-demand and underserved",
        "Point5": "Available in Washington, Oregon, California, Arizona, Texas and Colorado",
        "Point6": "and more locations <b>coming soon...</b>"
      }
    },
    "Section8": {
      "Title": "Security and Regulatory Compliance",
      "Paragraph": "Sendola collects KYC information from the account holder, the sender, and the recipient of every transaction processed by Sendola Global Payments comparable with the most comprehensive in the market to reduce regulatory risk and increase transaction safety",
      "Card1": {
        "Title": "User KYC",
        "Content": "Compile personal and identity information on account holder initiating transaction with the help of your institution."
      },
      "Card2": {
        "Title": "Beneficiary KYC",
        "Content": "Compile beneficiary information to comply KYC standards for N2, N3 and N4 accounts."
      },
      "Card3": {
        "Title": "OFAC and PEPs",
        "Content": "Transaction monitoring for the Office of Foreign Assets Control and Politically Exposed Persons Lists."
      },
      "Card4": {
        "Title": "Watchlists Validation",
        "Content": "User validated against +100 blacklists based on our security partners and payment networks."
      },
      "Card5": {
        "Title": "Account Usage",
        "Content": "Collect location data (coordinates) when the user sends money."
      },
      "Card6": {
        "Title": "Data Warehousing",
        "Content": "Data storage up to 10 years in the US and other countries (as required by regulations)."
      },
      "Card7": {
        "Title": "Transaction Limits",
        "Content": "Origination “velocity limits” imposed to enhance security."
      },
      "Card8": {
        "Title": "Limits by Channel",
        "Content": "Level of scrutiny determined by size of sending and delivery method."
      }
    },
    "Section9": {
      "Title": "Join our Bank Network",
      "Subtitle": "Schedule a call with our team!",
      "Button": "Contact us"
    }
  },
  "AboutUs": {
    "Heading": "Our Team",
    "Subtitle1": "Building a world where global ",
    "Subtitle2": "payments are for everyone",
    "LeadershipSection": "Leadership",
    "Leadership1": {
      "name": "Enrique Huesca",
      "position": "Chief Executive Officer"
    },
    "Leadership2": {
      "name": "Daniel Huerta",
      "position": "Head of SendolaPay - Business"
    },
    "Leadership3": {
      "name": "Paola Cortés",
      "position": "Chief Legal Officer"
    },
    "Leadership4": {
      "name": "Edgar Herrera",
      "position": "Head of SendolaPay - Personal"
    },
    "Leadership5": {
      "name": "Eduardo Rivera",
      "position": "Chief Financial Officer"
    },
    "LeadersSection": "Team Leaders",
    "Leader1": {
      "name": "María José Huesca",
      "position": "Business Development Relations"
    },
    "Leader2": {
      "name": "Salvador Rochin",
      "position": "Operations Director - Business"
    },
    "Leader3": {
      "name": "Gustavo Herrera",
      "position": "Chief Product and Technology Officer"
    },
    "Leader4": {
      "name": "",
      "position": "Engineering Manager"
    },
    "Leader5": {
      "name": "Alejandro Creel",
      "position": "Head of Design"
    },
    "Leader6": {
      "name": "Perla Alvarado",
      "position": "Head of Growth"
    },
    "Leader7": {
      "name": "Marlia Alarcón",
      "position": "Chief Project Manager"
    },
    "Leader8": {
      "name": "Mariana Cuervo",
      "position": "Financial Controller"
    },
    "Leader9": {
      "name": "Boomer Carr",
      "position": "Head of Sales Operations & Client Experience"
    },
    "Leader10": {
      "name": "Israel Sosa",
      "position": "Operations Director - Personal"
    },
    "Leader11": {
      "name": "Renee Triay",
      "position": "Head of Sales"
    },
    "Leader12": {
      "name": "Ilse Murillo",
      "position": "Networks and Concierge Support"
    },
    "Leader13": {
      "name": "Juan David Gómez",
      "position": "Head of Business Intelligence"
    }
  },
  "SendolaBlack": {
    "Title": "Unlock Global Success with Our Premium Payments Service",
    "Section1": {
      "Title": "Streamline Your Transactions, Maximize Your Savings",
      "Paragraph1": "Our <b>premium global payments service</b> offers high-level clients an unparalleled opportunity to enhance the <b>efficiency</b> of their large transactions while <b>saving</b> significantly <b>on costs.</b>",
      "Paragraph2": "Discover how our service stands apart from traditional banking options, such as international wires, and why <b>it's time to elevate your payment processes.</b>"
    },
    "Section2": {
      "Title": "Bank-grade security protocols to protect your transactions"
    },
    "Section3": {
      "Title": "Why Choose Us?",
      "Subtitle": "Freedom to move money seamlessly across the globe",
      "Card1": {
        "Title": "Cost-Effective Solutions",
        "Paragraph1": "<b>Reduce transaction fees and spreads,</b> cutting your costs significantly compared to traditional banking.",
        "Paragraph2": "<b>Enjoy clear pricing</b> that helps you save on every transaction."
      },
      "Card2": {
        "Title": "Global Reach",
        "Paragraph1": "Our service allows you to <b>seamlessly send money to Mexico</b> with other destination countries coming soon, <b>simplifying your operations</b> and empowering you to capitalize on new opportunities."
      },
      "Card3": {
        "Title": "Dedicated Support",
        "Paragraph1": "<b>A tailored service with a concierge experience</b> that simplifies your life, supported by a dedicated team who understands the intricacies of global payments and is committed to your success"
      }
    },
    "Section4": {
      "Title": "Skip the bank wires— connect with your counterparties internationally with just a few clicks, all backed by premium concierge support."
    },
    "Section5": {
      "Title": "Office Hours Premium Support",
      "Subtitle": "Contact Methods",
      "Method1": "Email Support",
      "Method2": "Phone Support",
      "Method3": "Live Chat"
    },
    "Section6": {
      "Quote": "Leave the fees behind, and embrace the adventure of living",
      "Title1": "Join the Movement",
      "Paragraph1": "Don't let traditional banking methods hold you back from achieving your business goals.",
      "Paragraph2": "<b>Sign up for our premium global payments</b> service today and experience the difference in <b>cost, efficiency, and security.</b> Transform the way you transact globally and take your business to new heights.",
      "Title2": "Get Started",
      "Paragraph3": "<b>Are you ready to transform borderless-banking transactions together?</b>",
      "Paragraph4": "Contact us now to learn more about our service and how we can help you <b>save money on large transactions</b> while providing unrivaled financial solutions for you.",
      "Button": "Apply today"
    },
    "Section7": {
      "Title": "How It Works:<br>Send Money in 3 Easy Steps",
      "Card1": {
        "Title": "Complete the Application Form",
        "Content": "Begin by filling out the Sendola Black application form online at www.sendola.io This simple form gathers key information to initiate the approval process for our Sendola Black service."
      },
      "Card2": {
        "Title": "Concierge Review",
        "Content": "Your application will be reviewed based on the information provided. The Sendola Black Concierge team will contact you via phone to finalize the application process."
      },
      "Card3": {
        "Title": "Send Premium Payments",
        "Content": "Once approved, you can immediately begin sending funds through the Sendola Black concierge team, ensuring seamless, secure transactions."
      },
      "Button": "Apply today"
    },
    "Section8": {
      "Title": "Cost Breakdown Table",
      "Subtitle": "Sending $10,000.00 to Mexico",
      "SavingsTitle": "*Savings for sending $10,000.00 USD with us:",
      "OtherBanks": "Other banks details",
      "FX": "FX Spread",
      "MXN": "MXN",
      "Card": {
        "Title": "Cost Breakdown Table",
        "Subtitle": "Sending $10,000.00 to Mexico",
        "Total": "Total Received:",
        "Card1": {
          "Name": "Other Banking Solutions",
          "Percentage": "3.2%",
          "Rate": "FX Rate $18.75*",
          "TotalAmount": "$184,523.88"
        },
        "Card2": {
          "Name": "",
          "Percentage": "1.5%",
          "Rate": "FX Rate $19.08*",
          "TotalAmount": "$190,758.05",
          "YouReceive": "You receive more pesos: $3,234.17 MXN",
          "YouSave": "You save (sending fee $25.00 USD): $476.90 MXN",
          "YourBenefit": "Your total benefit: $3,711.07 MXN"
        }
      },
      "Disclaimer1": "*This is an example of sending $10,000 from the U.S. to Mexico using WIRE TRANSFER as the payment method through Sendola Black, compared to standard international transfer using Bank Account.",
      "Disclaimer2": "*Example created using exchange rate information from October 11, 2024, 10:30 am CST."
    },
    "Section9": {
      "Title": "Transaction Limits Tailored to Your Needs",
      "Subtitle": "Whether you're sending payments for rent, property maintenance, or making larger investments, Sendola's service is designed to accommodate your specific requirements",
      "Disclaimer1": "*Limits based on risk assessment ",
      "Disclaimer2": "*Restrictions apply"
    },
    "Section10": {
      "ApplyTitle": "Begin the Sendola Black Experience",
      "ApplyButton": "Apply today",
      "Title": "Frequently Asked Questions",
      "Question1": {
        "Question": "How long does it take to process a transfer?",
        "Answer": "Up to 3 business days, depending on the payment method and the destination country you select."
      },
      "Question2": {
        "Question": "What are the available Payment Method options? ",
        "Answer": "You can choose Wire Transfer for same-day or next-day execution, or select one of the following options based on your convenience:",
        "Bullet1": "ACH pull - You must keep the funds in your account until you receive confirmation from Sendola.",
        "Bullet2": "Zelle - The user sends the funds to Sendola via Zelle. ",
        "Details": "For more details, see the Payment Methods, Fund Reception, and Credit Time table."
      },
      "Question3": {
        "Question": "Table of Payment Methods, Fund Reception, and Credit Time table:",
        "Answer": "See or download table"
      },
      "Question4": {
        "Question": "What countries can I send money to?",
        "Answer": "Currently, you can send money to Mexico, with more countries coming soon, including Guatemala, Canada, and Portugal."
      },
      "Question5": {
        "Question": "How secure is my transaction?",
        "Answer": "Sendola uses bank-grade encryption and compliance standards to ensure your funds are secure.<br>Our concierge team works directly with you, providing immediate assistance and updates on your transaction status, ensuring complete peace of mind from start to finish."
      }
    }
  },
  "ClaroPay": {
    "title": "Do you send or receive money <span>from the U.S.</span>?",
    "doItWith": "Do it with",
    "sendNow": "Send now!",
    "sendMoneyNow": "Send money now!",
    "knowMore": "Learn more",
    "receiveMoney": "Receive your money through",
    "orAnyAccount": "or any bank account in Mexico",
    "benefitsTitle": "Benefits of receiving money with Claro Pay",
    "askFor": "Ask them to send you",
    "coupon": {
      "title": "The more you send, the more you save!",
      "subtitle": "Claim your welcome coupon:",
      "couponName": "HOLACLAROPAY",
      "description": "Send $100 – <span>Pay Only $99</span>",
      "disclaimer": "Offer: Get $1 off for every $100 you send. Valid on transfers starting at $100. Ends August 31, 2025."
    },
    "lines": {
      "line1": "Get <span>more pesos for your dollars</span>",
      "line2": "Get <span>MEGAS</span> on your Telcel line when you receive money*",
      "line3": "<span>Pay for utilities</span> like electricity, water, gas, and internet — all from home",
      "disclaimer": "Every peso received from the U.S. turns into MEGAS for your linked Telcel number. Limited to 4GB per user per calendar month, with a maximum of 2GB per transaction."
    },
    "learnMore": "Learn More.",
    "requestNow": "Apply now",
    "threeSteps": "Send money in 3 simple steps:",
    "featuresCard": {
      "title": "Don't have a Claro Pay account yet?",
      "subtitle": "Discover everything it can do:",
      "feature1": "<span>Receive money from the U.S. and earn MEGAS</span> with every transfer",
      "feature2": "<span>Top up and pay your mobile plan</span> with Telcel, Claro, Movistar, Tigo, and more.",
      "feature3": "<span>Pay for utilities</span> like electricity, water, gas, and internet — no need to leave home.",
      "feature4": "<span>Instantly send and receive money</span> with other Claro Pay users.",
      "feature5": "<span>Withdraw cash</span> at over 5,000 locations, including ATMs and retail partners.",
      "feature6": "<span>Shop at over 11,000 stores</span> using your app."
    },
    "form": {
      "title": "Contact us",
      "subtitle": "We'd love to hear from you."
    },
    "cards": {
      "card1": "Open your account with Sendola Pay and start the experience.",
      "card2": "Register your details to send money to Mexico and other destinations.",
      "card3": "Add beneficiaries with a Claro Pay Inbursa account and send money — and MEGAS."
    },
    "welcomeTo": "Welcome to",
    "discover": "Discover what you can do!",
    "receiveInMainBanks": "Send money to the <span>major banks and cash pickup locations</span> across the country.",
    "banksAndMore": "BBVA, Banorte, Banco Azteca, BanCoppel, OXXO, Elektra, Farmacias Guadalajara, <span>and more!</span>",
    "signUp": "Send Now",
    "mockDisclaimer": "*Rates, fees, and exchange rates are for illustrative purposes only and are subject to change without notice.",
    "paymentMethodOptions": "<span>Fund your transfers</span> with any U.S. bank or payment method, including:",
    "sendolaOpenAccount": "Open Account",

    "moneyIntoData": "Every time you send money, the recipient gets free Telcel Megas as a bonus.",
    "disclaimer": "*Applies to Claro Pay Inbursa account transfers.",
    "promoDetails": "To learn more about the promotions, <a href='{{link}}' target='_blank' rel='noopener noreferrer'>click here</a>.",
    "mainFeatures": {
      "moreThanMoney1": "Get ready to send",
      "moreThanMoney2": "than money"
    },
    "sendToAccountDescription": "<b>Link your Claro Pay account</b> or someone else's and <b>transfer money</b> easily, quickly and without complications!",
    "requestYourAccount": "Activate your account today",
    "discoverAll": "Learn about some of the benefits",
    "youCanDo": "of the Claro Pay Inbursa account:",
    "openAccount": "I am interested",
    "quoteDisclaimer": "The prices, commissions, quotation and exchange rates are only illustrative and subject to change without prior notice.",
    "claroTermsDisclaimer": "Check the Terms and Conditions in the Claro Pay app.",
    "inviteFriends": "Invite your friends to enjoy the benefits of",
    "invite": "Invite",
    "apply": "Request now",
    "features": {
      "rechargeGift": "<b>Get free Megas</b> on recharges, packages and Telcel bills.",
      "buyInStores": "Shop at Sears or Sanborns and <b>get 5% cash back</b>.",
      "sanbornsDiscount": "<b>10% discount</b> when paying at <b>Sanborns</b> restaurant.",
      "starMedicaDiscount": "Get <b>10% off</b> on Laboratory and Imaging services at <b>StarMédica</b>.",
      "rechargeAccount": "<b>Get free Megas</b> when you recharge or pay your Telcel bill.",
      "payYourServices": "Pay <b>electricity, water, gas, internet</b> and many other bills.",
      "withdrawMoney": "<b>Withdraw cash</b> at more than 5,000 locations, including ATMs."
    }
  }
}